export default __webpack_public_path__ + "static/media/Leaders_IMG-TanChien-02.5e5764ea.png";